Namespace 'Customer.Ticket'

class Customer.Ticket.Integrations extends Backbone.Model

  initialize: (attributes, {ticket}) ->
    @initializeIntegrations(ticket)
    @listenTo(@get('salesforce'), 'ticket:searchcontacts:success', @_onSearchContactsSuccess)
    @listenTo(@get('salesforce'), 'ticket:export:success', @_onExportSuccess)
    @listenTo(@get('patagonia'), 'ticket:export:success', @_onExportSuccess)

  initializeIntegrations: (ticket) =>
    @set('salesforce', new Customer.Ticket.Integration.Salesforce(@get('salesforce'), {ticket}))
    @set('patagonia', new Customer.Ticket.Integration.Patagonia(@get('patagonia'), {ticket}))

  _onSearchContactsSuccess: (matching_contacts) =>
    @trigger('ticket:searchcontacts:success', matching_contacts)

  _onExportSuccess: =>
    @trigger('ticket:export:success')
